import memoizeOne from 'memoize-one';

export const stringValueParser = memoizeOne((rawValue: any): string | undefined => {
  if (!rawValue) return undefined;
  return rawValue;
});
